<template>
  <div class="table-responsive" :key="tableKey">
    <h1>Jobs Due Today</h1>
    <table id="jobs-due-today-table" class="table table-hover">
      <thead>
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Name</th>
          <th scope="col">Asset</th>
          <th scope="col">Driver</th>
          <th scope="col">Type</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody v-if="jobs">
        <tr v-for="job in jobs" :key="job.id" :class="job.table_theme">
          <th scope="row">{{ job.id }}</th>
          <td>
            <a :href="job.url">{{ job.name }}</a>
          </td>
          <td>{{ job.asset }}</td>
          <td>{{ job.driver }}</td>
          <td>{{ job.type }}</td>
          <td>{{ job.status }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr colspan="6">
          <td class="text-center">No jobs due today!</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jobs: [],
      tableKey: 0,
    };
  },
  props: {
    userId: {
      type: Number,
      required: true
    },
    companyToken: {
      type: String,
      required: true,
    },
  },
  created() {
    this.fetchJobsAndUpdateDatatable();

    window.Echo.private(`jobs.due.today.${this.companyToken}`).listen("JobsTodayUpdated", (e) => {
      this.fetchJobsAndUpdateDatatable();
    });
  },
  methods: {
    fetchJobsAndUpdateDatatable() {
      // Declare this so it can be used inside he axios
      var that = this;

      // Clear and destroy old Datatable if it exists
      $("#jobs-due-today-table").DataTable().clear().destroy();

      // Fetch all jobs due today for a specific company
      axios.get("/admin/jobs/due-today", {
        params: {
          userId: this.userId,
          token: this.companyToken,
        },
      })
      .then(function (response) {
        // Update the tableKey so the component will rerender itself
        that.tableKey += 1;
        that.jobs = response.data.jobs;

        // Wait for the jobs variable to be assigned to and only on the next tick create the Datatable
        that.$nextTick(() => {
          $("#jobs-due-today-table").DataTable({
            aLengthMenu: [
              [5, 10, 15, -1],
              [5, 10, 15, "All"],
            ],
            iDisplayLength: 10,
            language: { search: "" },
            order: [],
          });
        });
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/vue/JobsDueToday.vue